/* A cozinha aberta. Spec 32. Progressive enhancement only; every feature
   works, or stays as it was, without this file. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Theme settings and the add label arrive on the script tag from
     snippets/av-font-faces-v2.liquid. The readout template arrives on the
     Ten Minute Test markup. No customer string is written in this file. */
  var self = document.currentScript;
  function flag(name) { return !self || self.getAttribute(name) !== 'false'; }
  var addMomentOn = flag('data-au-add-moment');
  var transitionsOn = flag('data-au-view-transitions');
  var addedLabel = (self && self.getAttribute('data-au-added')) || '';

  /* B1 O Teste dos Dez Minutos -------------------------------------------- */
  function initTen(root) {
    if (root.dataset.auTenReady) return;
    var range = root.querySelector('[data-au-ten-range]');
    var controls = root.querySelector('[data-au-ten-controls]');
    var readout = root.querySelector('[data-au-ten-readout]');
    var jumps = root.querySelectorAll('[data-au-ten-jump]');
    if (!range || !controls || !readout) return;
    root.dataset.auTenReady = '1';
    var template = readout.getAttribute('data-template') || '__M__';
    var announceTimer = null;

    function text(minutes) { return template.replace('__M__', String(minutes)); }

    function set(value, announce) {
      var v = Math.max(0, Math.min(10, parseInt(value, 10) || 0));
      root.style.setProperty('--au-clock-value', v);
      range.value = v;
      range.setAttribute('aria-valuetext', text(v));
      for (var i = 0; i < jumps.length; i++) {
        jumps[i].setAttribute('aria-pressed', String(parseInt(jumps[i].getAttribute('data-au-ten-jump'), 10) === v));
      }
      if (announce) {
        clearTimeout(announceTimer);
        announceTimer = setTimeout(function () { readout.textContent = text(v); }, 250);
      } else {
        readout.textContent = text(v);
      }
      if (v === 10 && !root.dataset.auTenCompleted) {
        root.dataset.auTenCompleted = '1';
        track('australia:ten_minute_complete');
      }
    }

    range.addEventListener('input', function () { set(range.value, true); });
    for (var j = 0; j < jumps.length; j++) {
      jumps[j].addEventListener('click', function (event) {
        set(event.currentTarget.getAttribute('data-au-ten-jump'), false);
        track('australia:ten_minute_jump');
      });
    }
    controls.hidden = false;
    root.classList.add('is-interactive');
    set(0, false);
    track('australia:ten_minute_view');
  }

  /* Avise-me. Every request goes to Klaviyo back in stock first, then the
     Shopify contact form submits as before, so the store keeps its copy while
     the Klaviyo flow is not live. Klaviyo gets at most 3 seconds. */
  function initAvise(form) {
    if (form.dataset.auAviseReady) return;
    var key = form.getAttribute('data-klaviyo-key');
    var variant = form.getAttribute('data-variant-id');
    if (!key || !variant || !window.fetch) return;
    form.dataset.auAviseReady = '1';
    form.addEventListener('submit', function (event) {
      if (form.dataset.auAviseSent) return;
      var email = form.querySelector('input[type="email"]');
      if (!email || !email.value || (email.checkValidity && !email.checkValidity())) return;
      event.preventDefault();
      form.dataset.auAviseSent = '1';
      var button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      var body = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email.value } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      };
      var done = false;
      function proceed() {
        if (done) return;
        done = true;
        HTMLFormElement.prototype.submit.call(form);
      }
      setTimeout(proceed, 3000);
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(proceed, proceed);
    });
  }

  /* B5 The add moment. The bag count ticks once and a polite status speaks. */
  var liveRegion = null;
  function say(message) {
    if (!message) return;
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    setTimeout(function () { liveRegion.textContent = message; }, 60);
  }
  /* The setting au_add_moment only switches the visual tick. The announcement
     for screen readers always runs, so turning the tick off never silences it. */
  function addMoment() {
    if (addMomentOn) {
      var bags = document.querySelectorAll('.av-header-cart');
      for (var i = 0; i < bags.length; i++) {
        var bag = bags[i];
        bag.classList.remove('au-bag-tick');
        void bag.offsetWidth;
        if (!reduceMotion) bag.classList.add('au-bag-tick');
      }
    }
    var existing = document.querySelector('[data-av-cart-status]');
    if (!existing || !existing.textContent.trim()) say(addedLabel);
  }
  ['theme:cart:add', 'av:cart:add', 'av:product-card-added'].forEach(function (name) {
    document.addEventListener(name, addMoment);
  });

  /* B5 View transitions. Name only the card that was clicked. --------------- */
  if (transitionsOn) initTransitions();
  function initTransitions() {
    window.addEventListener('pageswap', function (event) {
      if (!event.viewTransition || !event.activation) return;
      var target = document.querySelector('[data-au-vt-source]');
      if (target) target.style.viewTransitionName = 'au-product';
    });
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.av-card11__media, a[href*="/products/"]');
      if (!link) return;
      var previous = document.querySelector('[data-au-vt-source]');
      if (previous) previous.removeAttribute('data-au-vt-source');
      var image = link.querySelector('img');
      if (image) image.setAttribute('data-au-vt-source', '');
    }, true);
    window.addEventListener('pagereveal', function (event) {
      if (!event.viewTransition) return;
      var main = document.querySelector('[data-av-pdp-state] img, .av-pdp-v3 img');
      if (main && document.body.getAttribute('data-page-type') === 'product') {
        main.style.viewTransitionName = 'au-product';
        event.viewTransition.finished.finally(function () { main.style.viewTransitionName = ''; });
      }
    });
  }

  /* Analytics: dispatch into the existing namespace, never invent a sink. */
  function track(name) {
    try {
      if (window.AVAnalytics && typeof window.AVAnalytics.custom === 'function') window.AVAnalytics.custom(name, {});
    } catch (e) { /* no-op */ }
  }

  function init(scope) {
    var root = scope || document;
    var tens = root.querySelectorAll('[data-au-ten]');
    for (var i = 0; i < tens.length; i++) initTen(tens[i]);
    var forms = root.querySelectorAll('form[data-au-avise]');
    for (var j = 0; j < forms.length; j++) initAvise(forms[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
